import { Stack } from "@fluentui/react";
import { LoadingOverlay } from "cayo.ui";
import { FC } from "react";
import { useIntl } from "react-intl";
import { commonMessages } from "@cayo/shared/messages/common";
import { AbortButton, DialogSafeOverlay } from "./styles";

interface CancellationPanelProps {
  onAbort: () => void;
}

export const CancellationPanel: FC<CancellationPanelProps> = ({ onAbort }) => {
  const intl = useIntl();

  return (
    <Stack>
      <DialogSafeOverlay>
        <LoadingOverlay />
        <AbortButton
          onClick={onAbort}
          text={intl.formatMessage(commonMessages.cancelRunningQuery)}
        />
      </DialogSafeOverlay>
    </Stack>
  );
};
